<div class="header">
    <div class="header-logo"></div>
    <ul class="header-list">
        <li class="header-item">
            <a href="https://www.15club.golf/" target="_self" class="header-link">About</a>
        </li>
        <li class="header-item">
            <a href="https://15thclub.freshdesk.com/" target="_self" class="header-link">Support</a>
        </li>
    </ul>
    <div class="header-mobile">
        <div class="header-menu-button" (click)="toggleMenu($event)">
            <span class="header-link">MENU</span>
        </div>
        <div class="header-mobile-content" *ngIf="isMenuOpened">
            <a href="https://www.15club.golf/" target="_self" class="header-mobile-link">About</a>
            <a href="https://15thclub.freshdesk.com/" target="_self" class="header-mobile-link">Support</a>
        </div>
    </div>
</div>